function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M3.5 4.5c-.103 0-.203.008-.302.023A2.5 2.5 0 015.5 3h9A2.5 2.5 0 0117 5.5v4.1a5.465 5.465 0 00-1-.393V5.5A1.5 1.5 0 0014.5 4h-9c-.513 0-.966.258-1.237.65A1.994 1.994 0 003.5 4.5zM9.207 16c.099.349.23.683.393 1H5.5A2.5 2.5 0 013 14.5V8.437a2.004 2.004 0 001 0V14.5A1.5 1.5 0 005.5 16h3.707zm.393-4c.183-.358.404-.693.657-1H7.5a.5.5 0 000 1h2.1zM3.5 5.5a1 1 0 100 2 1 1 0 000-2zm4 2.5a.5.5 0 000 1h5a.5.5 0 000-1h-5zM19 14.5a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm-4-2a.5.5 0 00-1 0V14h-1.5a.5.5 0 000 1H14v1.5a.5.5 0 001 0V15h1.5a.5.5 0 000-1H15v-1.5z"
});

function SvgCustomPropertiesOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgCustomPropertiesOutlined;